import { render, staticRenderFns } from "./UserEmailButton.vue?vue&type=template&id=1b59113c&"
import script from "./UserEmailButton.vue?vue&type=script&lang=js&"
export * from "./UserEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports